import { defaultCap } from '@anm/data/streaming/destinationsCaps';

const WAVE_FB_LIVES_LINK = 'https://wave.video/lives/facebook';
export const FB_GROUP_HINT = `I'm going live using Wave.video! Please grant Wave.video permissions to see your name in comments at ${WAVE_FB_LIVES_LINK}`;

const newLineHint = `\n\n${FB_GROUP_HINT}`;

export const getFbDescription = (text: string | null = '') =>
  text?.includes(WAVE_FB_LIVES_LINK)
    ? text || ''
    : text?.length === 0
    ? FB_GROUP_HINT
    : text && text.length > 0 && text.length < defaultCap.descriptionMaxLength - newLineHint.length
    ? `${text}${newLineHint}`
    : text || '';
